<ng-container *ngIf="{ value: currentFilterSelections$ | async } as currentFilterSelections">
  <ng-container *ngFor="let filterGroup of filterGroups$ | async">
    <div
      *ngIf="filterGroup.options.length > 0"
      class="client-request-filter-group p-4 d-flex flex-column gap-2 align-items-stretch bg-color-white rounded-all-1"
      [dataSelector]="dataSelector + '-group-' + filterGroup.type"
    >
      <label class="body-600 color-gray-100" [dataSelector]="dataSelector + '-group-' + filterGroup.type + '-label'">
        {{ filterGroup.label ?? filterGroup.type }}
      </label>

      <ng-container *ngFor="let option of filterGroup.options">
        <mat-checkbox
          *ngIf="{ value: currentFilterSelections.value[filterGroup.type]?.[option.id] } as isSelected"
          [checked]="isSelected.value"
          (change)="onFilterOptionChange(filterGroup.type, option.id, $event.checked)"
          class="mat-checkbox-stretch-label mat-checkbox-align-checkbox-top"
          [dataSelector]="dataSelector + '-option-' + filterGroup.type + '-' + option.id"
        >
          <div class="d-flex align-items-baseline justify-content-between w-100">
            {{ option.label }}

            <ng-container *ngIf="{ value: option.matchingIncompleteRequestsCount$ | async } as matchingCount">
              <pill
                *ngIf="matchingCount.value != undefined"
                size="small"
                [color]="isSelected.value ? 'primary' : 'gray'"
                [value]="matchingCount.value"
                [dataSelector]="dataSelector + '-count-' + filterGroup.type + '-' + option.id"
              ></pill>
            </ng-container>
          </div>
        </mat-checkbox>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
